import { cn } from "@/lib/utils";

const statusColors = {
  active: { dot: 'bg-cool-mint', text: 'text-cool-mint' },
  pending: { dot: 'bg-soft-amber', text: 'text-soft-amber' },
  inactive: { dot: 'bg-muted-text', text: 'text-muted-text' },
  error: { dot: 'bg-signal-red', text: 'text-signal-red' },
  live: { dot: 'bg-cool-mint animate-pulse', text: 'text-cool-mint' },
  upcoming: { dot: 'bg-electric-ice-blue', text: 'text-electric-ice-blue' },
};

export const StatusLight = ({ 
  status = 'active', 
  label,
  className 
}) => {
  const colors = statusColors[status] || statusColors.active;
  
  return (
    <div 
      className={cn("flex items-center gap-2", className)}
      data-testid="status-light"
    >
      <span className={cn("w-2 h-2 rounded-full", colors.dot)} />
      <span className={cn("text-sm", colors.text)}>
        {label || status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    </div>
  );
};

export default StatusLight;
